import { Client } from '@stomp/stompjs';
// the dist build avoids the "global is not defined" error of the node build under Vite
import SockJS from 'sockjs-client/dist/sockjs';

import { Config } from './config';

// backend endpoint: {contextPath}/ws -> /api/ws
const WS = `${Config.domain}/api/ws`;

export const BROADCAST_TOPIC = '/topic/notifications';
export const USER_QUEUE = '/user/queue/notifications';

let client = null;

/**
 * Opens the STOMP connection (if not already open) and subscribes to the
 * broadcast topic and, when a token is given, to the user's private queue.
 * Returns a function that closes the connection.
 */
export const connectSocket = (token, onNotification) => {
    disconnectSocket();

    client = new Client({
        webSocketFactory: () => new SockJS(WS),
        // the backend reads the JWT from the STOMP CONNECT frame
        connectHeaders: token ? { Authorization: `Bearer ${token}` } : {},
        reconnectDelay: 5000,
        heartbeatIncoming: 10000,
        heartbeatOutgoing: 10000,
        debug: Config.isDevelopment ? (str) => console.log(str) : () => {},
    });

    const handleMessage = (message) => {
        try {
            onNotification(JSON.parse(message.body));
        } catch {
            onNotification({ message: message.body });
        }
    };

    // subscriptions must be (re)done here so they survive reconnects
    client.onConnect = () => {
        client.subscribe(BROADCAST_TOPIC, handleMessage);

        if (token) {
            client.subscribe(USER_QUEUE, handleMessage);
        }
    };

    client.onStompError = (frame) => {
        console.error(`Broker reported error: ${frame.headers.message}`, frame.body);
    };

    client.activate();

    return disconnectSocket;
};

export const disconnectSocket = () => {
    if (client) {
        client.deactivate();
        client = null;
    }
};
